<template>
    <BCard
        :class="{'has-header': hasHeader}"
        v-bind="bCardProps"
    >
        <template #header>
            <div
                v-if="hasHeader"
                class="card-header-content"
            >
                <h2 class="card-title m-0">
                    <!-- content to be displayed in the title section, in the top left of the Card header -->
                    <slot name="title" />
                </h2>

                <div class="card-actions">
                    <!-- content to be displayed in the actions section, in the top right of the Card header -->
                    <slot name="actions" />
                </div>
            </div>
        </template>

        <!-- default content to show in the Card body -->
        <transition-group
            name="fade"
            mode="out-in"
        >
            <KCLoadingIndicator
                v-if="loading"
                key="loading"
                :loading="loading"
            />
            <div
                v-else
                key="loaded"
            >
                <slot />
            </div>>
        </transition-group>
    </BCard>
</template>

<script>
    import KCLoadingIndicator from './KCLoadingIndicator.vue';

    /**
     * @group Content
     * A card component to utilize the card styling and layout as defined by the UX Style Guide.
     */
    export default {
        name: 'Card',
        components: {KCLoadingIndicator},
        props: {
            // Props that should be passed onto the `b-card` instance.
            bCardProps: {
                type: Object,
                required: false,
                // `{}`
                default() {
                    return {};
                },
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            hasHeader() {
                return !!this.$slots.title || !!this.$slots.actions;
            },
        },
    };
</script>

<style
    lang="sass"
    scoped
>
    .fade-leave-active
        position: fixed

    .fade-enter-active, .fade-leave-active
        transition: opacity .3s

    .fade-enter, .fade-leave-to
        opacity: 0
</style>
